/**
 * 照らす「月報」パターン ギャラリー（DEV/デモ専用・月報のみ）。
 * ?m=CODE で1パターン単票（PDF生成用）。既定は全アーキタイプ表示。
 */
import React from 'react';
import { Box, Paper, Typography, Divider } from '@mui/material';
import { TerasuReport } from './TerasuReport';
import { generateDummyTerasuReport } from '../utils/generateDummyTerasuReport';
import { monthlyAllPatterns } from '../utils/demoTerasuPatterns';

export const TerasuMonthlyPatternsDemoPage: React.FC = () => {
  const params =
    typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : new URLSearchParams();
  const m = params.get('m');

  const all = monthlyAllPatterns();
  if (m) {
    const p = all.find((x) => x.code === m);
    if (!p) return <Box sx={{ p: 3 }}>該当パターンなし</Box>;
    const data = generateDummyTerasuReport({ monthGrid: p.monthGrid });
    return (
      <Box sx={{ maxWidth: 720, mx: 'auto', px: 2, py: 3 }}>
        <Paper variant="outlined" sx={{ p: 1, mb: 1, bgcolor: '#E8F5E9' }}>
          <Typography variant="subtitle1" fontWeight={700}>
            月報｜{p.label}
          </Typography>
        </Paper>
        <TerasuReport data={data} mode="monthly" />
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 760, mx: 'auto', px: 2, py: 3 }}>
      <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6">GBなび 月報パターン（アーキタイプ{all.length}）</Typography>
        <Typography variant="body2" color="text.secondary">
          月報のみ。4週の天気推移アーキタイプ（全指標一律6＋1指標だけ悪化4）。?m=CODE で単票。
          ※月報の天気グリッドは4指標×4週で全網羅は非現実的なため代表アーキタイプ。
        </Typography>
      </Paper>
      {all.map((p) => {
        const data = generateDummyTerasuReport({ monthGrid: p.monthGrid });
        return (
          <Box key={p.code} sx={{ mb: 4 }}>
            <Paper variant="outlined" sx={{ p: 1, mb: 1, bgcolor: '#E8F5E9' }}>
              <Typography variant="subtitle1" fontWeight={700}>
                {p.label}
              </Typography>
            </Paper>
            <TerasuReport data={data} mode="monthly" />
            <Divider sx={{ mt: 3 }} />
          </Box>
        );
      })}
    </Box>
  );
};

export default TerasuMonthlyPatternsDemoPage;
